import Timeoff from "../models/Timeoff";
import { TimeOffActions, TimeOffStatus } from "../utils/enums/TimeOffStatus";
import { TextFieldComponent } from "../external/ensolvers-core-frontend-mui/components/Common/FormComponents";
import { Alert, Box } from "@mui/material";
import { useEffect, useState } from "react";
import TimeoffService from "../services/TimeoffService";
import VacationReport from "../models/VacationReport";
import NotificationService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import { TimeOffType } from "../types/TimeOffType";
import { useFeatureToggle } from "../external/ensolvers-core-frontend-mui/hooks/useFeatureToggle";
import { Features } from "../utils/Features";
import featureToggleList from "./../utils/toggleConfig.json";
import AlertComponent from "./AlertComponent";

interface Props {
  title: string;
  message: string;
  timeoff: Timeoff | undefined;
  extraButton?: boolean;
  onClose: () => void;
  handleApproval: (data: Timeoff, status: TimeOffStatus) => void;
  handleExtraFunction: (data: Timeoff, status: TimeOffStatus) => void;
  missingDocumentation?: boolean;
}

export default function TimeOffStatusDialog(props: Props) {
  const [vacationReport, setVacationReport] = useState<VacationReport | undefined>(undefined);
  const [vacationLeftAfterApproval, setVacationLeftAfterApproval] = useState<number>(0);
  const [isVacationReportEnabled] = useFeatureToggle(featureToggleList, Features.VACATION_REPORT);

  useEffect(() => {
    if (props.timeoff?.type === TimeOffType.VACATION && isVacationReportEnabled) {
      getVacationBalance();
    }
  }, []);

  const getVacationBalance = () => {
    var calculationDate = new Date(props.timeoff!.shortEndDate);

    TimeoffService.getVacationBalance(props.timeoff?.requesterExternalId!, calculationDate!.getFullYear(), calculationDate!.getMonth() + 1)
      .then((response) => {
        setVacationReport(response.getContentOrThrowError());
        setVacationLeftAfterApproval(response.getContentOrThrowError().vacationsLeft - props.timeoff?.totalDays!);
      })
      .catch((err) => NotificationService.error(err.message));
  };

  const getExtraButton = () => {
    if (props.timeoff?.status === TimeOffStatus.PENDING && props.extraButton) {
      return [
        {
          label: TimeOffStatus.ADD_DOCUMENTATION,
          onClick: () => props.handleExtraFunction(props.timeoff!, TimeOffStatus.ADD_DOCUMENTATION),
        },
      ];
    } else {
      return [];
    }
  };

  if (!props.timeoff) {
    return null;
  }
  return (
    <AlertComponent
      title={props.title}
      message={props.message}
      confirmLabel={TimeOffActions.APPROVE}
      onConfirm={(data) => props.handleApproval(data, TimeOffStatus.APPROVED)}
      cancelLabel={TimeOffStatus.REJECTED}
      onCancel={(data) => props.handleApproval(data, TimeOffStatus.REJECTED)}
      extraButtons={getExtraButton()}
      renderContent={(register, errors, control) => (
        <Box sx={{ "& .MuiFormControl-root": { margin: 0, marginTop: "1rem" } }}>
          {props.missingDocumentation && (
            <Alert severity="warning" sx={{ ml: "0.5em", mb: "1em" }}>
              Warning: The requested documentation hasn't been added yet
            </Alert>
          )}
          <TextFieldComponent
            control={control}
            register={register}
            errors={errors}
            propertyName={"statusReason"}
            label="Reason for approval/reject"
            internalProps={{ multiline: true, rows: 6 }}
            size="small"
          />
          {isVacationReportEnabled && vacationReport && (
            <div>
              <label style={{ display: "block", marginTop: "0.5em" }}>
                {"Accumulated Vacations: " + vacationReport?.vacationsAccumulated.toFixed(2) + " days"}
              </label>
              <label style={{ display: "block", marginTop: "0.5em" }}>
                {"Approved / Taken Vacations: " + vacationReport?.vacationsApproved.toFixed(2) + " days"}
              </label>
              <label style={{ display: "block", marginTop: "0.5em", color: vacationLeftAfterApproval < 0 ? "red" : "green" }}>
                {"Left Vacations After Approval: " + vacationLeftAfterApproval.toFixed(2) + " days"}
              </label>
            </div>
          )}
        </Box>
      )}
      onClose={() => props.onClose()}
    />
  );
}
